import TcmSelect from './src/main';

/* istanbul ignore next */
TcmSelect.install = function(Vue) {
  Vue.component(TcmSelect.name, TcmSelect);
};

export default TcmSelect;
